module.exports = __webpack_public_path__ + "static/content-3-da4fdc6e30772e39bd14dfbc3f898ca8.png";